import React, { Fragment } from 'react'
import { FormGroup, Button, Card, Col, CardBody, Row, CardHeader, Label, Input} from 'reactstrap';
import 'animate.css';
import Select from 'react-select';
import "react-datetime/css/react-datetime.css";
import './styleQuoterMic.css';
import { DialogPreviewPdfSamplingSheet } from './DialogPreviewPdfSamplingSheet';
import { TableListQuoterMic } from './ComponentQuoter/TableListQuoterMic';
import { DialogPreviewQuoterPdf } from './DialogPreviewQuoterPdf';
export const IndexQuoteList = ({setActiveIndex, quoterHook}) => {

	const {
        
		//*TYPE CLIENT
        listCompanies,
  
        //*FORM MIC
        formQuoterMic,

		//*VIEW QUOTER
		loadingCreate,
        
        //*CREATE
        handleNavigateSampling,

		//*
		informationQuatation,

		getSearchQuoter,handleFilterValues,handleSearchClient,

		getFilter,handleCleanFilter,
		
		downdloadpdfSampling,navigateUpdate,navigateIngress,
       
		//* PDF QUOTER PREVIEW
		PreviewQuoter,

		 //* PDF Sampling Sheet
        showPreviewSamplingSheet, setShowPreviewSamplingSheet,setPdfPreviewSamplingSheet, pdfPreviewSamplingSheet, handleDownloadPdf, loadingPdf, currentCode, currentQuoter,
 
		//*PREVIW PDF
		pdfPreviewQuoter, showPreviewPdfQuoter, setShowPreviewPdfQuoter, loadingPdfQuoter, downloadQuoter
	} = quoterHook;
	

	
	
	return (
		<Fragment>	
			<Row>
				<Col sm="3"style={{ textAlign: "left" }}>
					<Card style={{
						boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
						border: 'none',
						height: '100%',
						borderRadius: '12px'
					}}>
						<CardHeader style={{
							background: 'linear-gradient(135deg, #0d3b59 0%, #1d5b83 100%)',
							color: 'white',
							padding: '15px',
							borderRadius: '12px 12px 0 0'
						}}>
							<h6 className="mb-0" style={{ fontWeight: 700, fontSize: '15px' }}>
								<i className="fa fa-filter mr-2"></i>Filtros de Búsqueda
							</h6>
						</CardHeader>
						<CardBody style={{ padding: '20px' }}>
							<FormGroup>
								<Label className='f-w-600 label-report'>
									<i className="fa fa-calendar-alt mr-2" style={{ color: '#007bff' }}></i>Fecha de inicio
								</Label>
								<Input
									type='date'
									name='start_date'
									value={formQuoterMic.start_date || ""}
									onChange={handleFilterValues}
									className='form-control'
									style={{
										borderRadius: '8px',
										border: '1px solid #ddd',
										padding: '10px',
										fontSize: '13px'
									}}
								/>
							</FormGroup>
							<FormGroup>
								<Label className='f-w-600 label-report'>
									<i className="fa fa-calendar-check mr-2" style={{ color: '#28a745' }}></i>Fecha de cierre
								</Label>
								<Input
									type='date'
									   name='end_date'
									value={formQuoterMic.end_date || ""}
									onChange={handleFilterValues}
									className='form-control'
									style={{
										borderRadius: '8px',
										border: '1px solid #ddd',
										padding: '10px',
										fontSize: '13px'
									}}
								/>
							</FormGroup>

							<FormGroup>
								<Label className='f-w-600 label-report'>
									Código
								</Label>
								<Input
									type='text'
									name='code_quatation' 
									value={formQuoterMic.code_quatation || ""}
									onChange={handleFilterValues}
									className='form-control'
									style={{
										borderRadius: '8px',
										border: '1px solid #ddd',
										padding: '10px',
										fontSize: '13px'
									}}
								/>
							</FormGroup>

							<FormGroup>
								<Label className='f-w-600 label-report'>
									Empresa
								</Label>
								<Select
									classNamePrefix="select"
									name="id_company_search"
									value={formQuoterMic.id_company_search}
									placeholder="Selecciona una empresa"
									options={listCompanies}
									onChange={(e) => handleSearchClient(e)}
									menuPortalTarget={document.body}																								
								/>
							</FormGroup>

							<br />
							<b>Acciones</b>
							<br /><br />
							<Button
								onClick={(e) => getFilter(e, true)}
								color="primary"
								block
								outline
								className="mb-3"
								style={{
									borderRadius: '10px',
									padding: '6px',
									fontSize: '14px',
									fontWeight: 600,
									borderWidth: '2px'
								}}
								onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
								onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
							>
								Buscar
							</Button>

							
							<Button
								color="danger"
									onClick={handleCleanFilter}
								block
								style={{
									borderRadius: '10px',
									padding: '6px',
									fontSize: '13px',
									fontWeight: 600,
									boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
									transition: 'all 0.3s'
								}}
								onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
								onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
								title="Limpiar Filtros"
							>
								
								Limpiar
							</Button>

						</CardBody>


					</Card>
				</Col>
				
				<Col sm="9" className="pr-4">

					<TableListQuoterMic 
						{
							...{
								handleNavigateSampling, loadingCreate, getSearchQuoter,
								downdloadpdfSampling, navigateUpdate, navigateIngress, 
								PreviewQuoter, setActiveIndex,informationQuatation
							}
						}
					/>

								
					
								
				</Col>
					
			</Row>

			<DialogPreviewPdfSamplingSheet
				{
					...{
							showPreviewSamplingSheet, setShowPreviewSamplingSheet,setPdfPreviewSamplingSheet, pdfPreviewSamplingSheet, handleDownloadPdf,informationQuatation, loadingPdf,
							currentCode, currentQuoter

					}
                        
				}
			/>

			
			<DialogPreviewQuoterPdf
				pdfPreviewQuoter={pdfPreviewQuoter}
				showPreviewPdfQuoter={showPreviewPdfQuoter}
				setShowPreviewPdfQuoter={setShowPreviewPdfQuoter}
				loadingPdfQuoter={loadingPdfQuoter}
				downloadQuoter={downloadQuoter}
				informationQuatation={informationQuatation}
			/>

        
		</Fragment >
	)
}




